import { Link } from '@mui/material';
import { Fields } from 'common/form';
import { TWILIO_PHONE_NUMBER_FORMAT_URL } from 'core/constants/urls';
import Yup from 'utils/validation';

const editCandidateSchema = Yup.object({
  firstName: Yup.string().required('Enter first name'),
  lastName: Yup.string().required('Enter last/family name'),
  email: Yup.string()
    .required('Enter email address in the correct format')
    .email('Enter email address in the correct format'),
  phoneNumber: Yup.string().required('Enter phone number')
});
export type EditCandidate = Yup.InferType<typeof editCandidateSchema>;

const editCandidateFields: Fields<EditCandidate> = {
  firstName: {
    label: 'First name',
    type: 'text'
  },
  lastName: {
    label: 'Last name',
    type: 'text'
  },
  email: {
    label: 'Email',
    subLabel: 'e.g. dave.smith@joinpopp.com',
    type: 'text'
  },
  phoneNumber: {
    label: 'Phone',
    subLabel: (
      <span>
        Use{' '}
        <Link href={TWILIO_PHONE_NUMBER_FORMAT_URL} target="_blank">
          E.164 numbering format
        </Link>{' '}
        for phone numbers.
      </span>
    ),
    type: 'text'
  }
};

export const editCandidateForm = {
  schema: editCandidateSchema,
  fields: editCandidateFields
};
